import { LoadingSVG, LogoSVG, PlanSVG, SlashSVG, SunraySVG } from '@src/svgs';

import {
  CustomSvgIconComponent,
  CustomSvgIconName,
  SVG_LOADING,
  SVG_LOGO,
  SVG_PLAN,
  SVG_SLASH,
  SVG_SUNRAY
} from '@src/types/svg';

export const findCustomSvgIcon = (
  name: CustomSvgIconName
): CustomSvgIconComponent | undefined =>
  customSvgIconDefinitions.find((c) => c.name === name);

const customSvgIconDefinitions: CustomSvgIconComponent[] = [
  {
    name: SVG_LOADING,
    component: LoadingSVG
  },
  {
    name: SVG_LOGO,
    component: LogoSVG
  },
  {
    name: SVG_PLAN,
    component: PlanSVG
  },
  {
    name: SVG_SLASH,
    component: SlashSVG
  },
  {
    name: SVG_SUNRAY,
    component: SunraySVG
  }
];

export default customSvgIconDefinitions;
